import { useState, useEffect } from "react";
import Select from 'react-select';

const CboEmpresa = ({ selectedValue, onChange, disabled, grupo, grusu, className }) => {

  const [empresas, setEmpresas] = useState([]);
  const [verEmpresas, setVerEmpresas] = useState(true);

  useEffect(() => {

    var json3;
    var jsons3;
    var url3;
    let consulta = new Object();

    consulta.grupo = grupo;
    consulta.grusu = grusu;
    console.log("cboEmpresa:", grupo, grusu);
    jsons3 = JSON.stringify(consulta);


    var options3 = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'

      },
      mode: 'cors',
      credential: 'include',
      body: jsons3,

    };

    url3 = `${process.env.REACT_APP_API_URL}/emp/allempresas`;



    fetch(url3, options3)
      .then(response => response.json())
      .then(data => {

        json3 = data;
        console.log("Empresas:", json3.data)
        if (json3.data.length > 0) {
          setVerEmpresas(true);
          const primerId = json3.data[0].Emp_IdEmp;
          // Creamos un objeto que simule el evento de cambio para no romper la lógica del componente padre
          const eventoSimulado = {
            target: {
              value: primerId
            }
          };
          onChange(eventoSimulado);
        }

        setEmpresas(json3.data);

      })


  }, [grupo, grusu]);

  const opcionesEmpresas = [
    { value: 0, label: 'todas las empresas' },

    ...empresas.map((unolista) => ({
      value: unolista.Emp_IdEmp,
      label: unolista.Emp_Nombre
    }))
  ];

  const empresaSeleccionada =
    opcionesEmpresas.find(op => op.value === selectedValue);






  return (
    /* 
              <select className={`form-control form-select mb-3 ${className} `} value={selectedValue} onChange={onChange} disabled={disabled}  >
    
                {empresas.map((unolista, index) => (
                  <option key={index + '_opt'} value={unolista.Emp_IdEmp}>{unolista.Emp_Nombre}</option>
                )
                )
                }
    
              </select> */

    <div className={verEmpresas ? "col-lg-offset-0 col-lg-2 col-xs-12 col-sm-4" : "col-lg-offset-0 col-lg-3 col-xs-12 col-sm-6 d-none"}>
      <div className="form-group">
        <label className="l" >
          Institución
        </label>

        <Select
          classNamePrefix="miSelect"
          isSearchable={false}
          options={opcionesEmpresas}
          value={empresaSeleccionada}
          onChange={(opcion) =>
            onChange({
              target: {
                value: opcion.value || 0
              }
            })
          }
          isDisabled={disabled}
        />






      </div>
    </div>

  );
};

export default CboEmpresa;